import { useMode } from "../context/ModeContext";

// Junior Blocks mural: the mine drill pinned to the left edge, the submarine to the right, behind the top of every page
// while Junior mode is active. Panels fade towards the content column and downwards (CSS masks, so the fade follows
// light/dark backgrounds) and scroll away with the page. Phones get a slim strip behind the page title.
const PANEL_H = 520;
const SIDE_MASK = { left: "linear-gradient(to right, black 45%, rgba(0,0,0,0.6) 70%, transparent 100%)", right: "linear-gradient(to left, black 45%, rgba(0,0,0,0.6) 70%, transparent 100%)" };
const DOWN_MASK = "linear-gradient(to bottom, black 35%, rgba(0,0,0,0.55) 70%, transparent 100%)";

const Panel = ({ side }) => (
  <div
    className={`absolute top-0 ${side === "left" ? "left-0" : "right-0"} hidden xl:block`}
    style={{ height: PANEL_H, WebkitMaskImage: SIDE_MASK[side], maskImage: SIDE_MASK[side] }}
    data-testid={`junior-mural-${side}`}
  >
    <img
      src={`/nav/mural_${side}.webp`}
      alt=""
      loading="eager"
      decoding="async"
      draggable={false}
      className="h-full w-auto max-w-none dark:brightness-[0.62] dark:saturate-[0.85]"
      style={{ WebkitMaskImage: DOWN_MASK, maskImage: DOWN_MASK }}
    />
  </div>
);

export const JuniorMural = () => {
  const { mode } = useMode();
  if (mode !== "junior") return null;
  return (
    <div className="absolute inset-x-0 top-0 -z-10 overflow-hidden pointer-events-none select-none" style={{ height: PANEL_H }} aria-hidden="true" data-testid="junior-mural">
      <Panel side="left" />
      <Panel side="right" />
      {/* Phones / tablets: slim strip across the top, fading down into the page */}
      <div className="xl:hidden absolute inset-x-0 top-0 h-[140px]" style={{ WebkitMaskImage: DOWN_MASK, maskImage: DOWN_MASK }} data-testid="junior-mural-strip">
        <img src="/nav/mural_wide.webp" alt="" loading="eager" decoding="async" draggable={false} className="w-full h-full object-cover object-top dark:brightness-[0.62] dark:saturate-[0.85]" />
      </div>
    </div>
  );
};
